import { InjectionToken } from '@angular/core';
import * as i0 from "@angular/core";
export class SfccConnectorFactoryService {
    constructor() { }
    getServiceToken(mode) {
        switch (mode) {
            case 'gated':
                return SfccConnectorFactoryService.SFCC_GATED;
            case 'generic':
                return SfccConnectorFactoryService.SFCC_GENERIC;
        }
    }
}
SfccConnectorFactoryService.SFCC_GATED = new InjectionToken('gated');
SfccConnectorFactoryService.SFCC_GENERIC = new InjectionToken('generic');
SfccConnectorFactoryService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SfccConnectorFactoryService_Factory() { return new SfccConnectorFactoryService(); }, token: SfccConnectorFactoryService, providedIn: "root" });
